import React from "react";
import { Container, Skeleton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import styles from "./deliveryLotsGuidesTableStyles.js";
import NoData from '../../../components/SharedComponents/NoData';
import GuidesTableActionsDelivered from "../GuidesTableActionsDelivered/index.js";
import { usePermissions } from "../../../hooks/permissions/usePermissions.js";

const DeliveryGuidesGuidesTable = ({
  guides = [],
  isLoading,
  search,
  fetchGuides,
}) => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 50,
      resizable: false,
      sortable: false,
      renderHeader: (params) => <strong>ID</strong>,
    },
    {
      field: "suggest_delivery_man",
      headerName: "REPARTIDOR",
      minWidth: 200,
      flex: 1,
      resizable: false,
      sortable: false,
      renderHeader: (params) => <strong>REPARTIDOR</strong>,
    },
    {
      field: "count_guides",
      headerName: "GUÍAS",
      type: "string",
      minWidth: 70,
      flex: 1,
      resizable: false,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderHeader: (params) => <strong>GUÍAS</strong>,
    },
    {
      field: "count_weight",
      headerName: "PESO",
      type: "string",
      minWidth: 70,
      flex: 1,
      resizable: false,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderHeader: (params) => <strong>PESO</strong>,
    },
    {
      field: "actions",
      headerName: "ACCIONES",
      type: "string",
      resizable: false,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderHeader: (params) => <strong>ACCIONES</strong>,
      renderCell: (params) => <GuidesTableActionsDelivered guide={params.row} />,
    },
  ];

  const filteredRows = guides.filter((guide) => {
    const transformedUser = {
      ...guide,
    };

    return Object.values(transformedUser).some((value) =>
      value.toString().toLowerCase().includes(search.toLowerCase())
    );
  });

  const rows = filteredRows?.map((guide, index) => ({
    id: guide.id_batch,
    suggest_delivery_man: guide.suggest_delivery_man,
    count_guides: guide.count_guides,
    count_weight: guide.count_weight,
    s3_qrcode: guide.s3_qrcode,
  }));

  const handleRowClick = (params) => {
    if (!hasPermission("rte_vwd_bat")) {
      return null;
    }
    navigate(`/rutas/${params.id}`);
  };

  return (
    <Container sx={styles.mainContainer}>
      {isLoading ? (
        <Container sx={styles.skeletonMainContainer}>
          <Container sx={styles.skeletonSecondaryContainer}>
            <Skeleton variant="rounded" width={'5%'} height={40} />
            <Skeleton variant="rounded" width={'10%'} height={40} />
            <Skeleton variant="rounded" width={'20%'} height={40} />
            <Skeleton variant="rounded" width={'10%'} height={40} />
            <Skeleton variant="rounded" width={'10%'} height={40} />
            <Skeleton variant="rounded" width={'10%'} height={40} />
            <Skeleton variant="rounded" width={'10%'} height={40} />
            <Skeleton variant="rounded" width={'10%'} height={40} />
            <Skeleton variant="rounded" width={'15%'} height={40} />
          </Container>
          <Container sx={styles.skeletonSecondaryContainer}>
            <Skeleton variant="rounded" width={'5%'} height={300} />
            <Skeleton variant="rounded" width={'10%'} height={300} />
            <Skeleton variant="rounded" width={'20%'} height={300} />
            <Skeleton variant="rounded" width={'10%'} height={300} />
            <Skeleton variant="rounded" width={'10%'} height={300} />
            <Skeleton variant="rounded" width={'10%'} height={300} />
            <Skeleton variant="rounded" width={'10%'} height={300} />
            <Skeleton variant="rounded" width={'10%'} height={300} />
            <Skeleton variant="rounded" width={'15%'} height={300} />
          </Container>
        </Container>
      ) : (
        <DataGrid
          autoHeight
          disableColumnFilter
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[10, 20, 50, 100]}
          disableColumnMenu={true}
          disableSelectionOnClick={true}
          localeText={{ 
            noRowsLabel: <NoData title="No se encontraron guías" />
          }}
          onRowClick={handleRowClick}
          sx={{
            '& .MuiDataGrid-row.unselectableRow': styles.unselectableRow,
            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { 
              py: '8px', 
              display: 'flex', 
              alignItems: 'center' 
            },
            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { 
              py: '6px', 
              display: 'flex', 
              alignItems: 'center' 
            },
            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { 
              py: '22px', 
              display: 'flex', 
              alignItems: 'center' 
            },
          }}
        />
      )}
    </Container>
  );
};

export default DeliveryGuidesGuidesTable;
